import { constructTheme } from 'assets/constructTheme';
import { ThemeVariant } from 'assets/theme/themeTypes';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'mobx/rootStore';
import { isIOS } from 'utils/constants';

export class UiStore {
  public rootStore: RootStore;

  public isIOS = isIOS();

  public currentThemeVariant = constructTheme(ThemeVariant.DARK);
  public lastPathnameBeforeSearch = '/';
  public lastSearchParamsBeforeSearch = '';

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  public setCurrentThemeVariant(variant: ThemeVariant) {
    this.currentThemeVariant = constructTheme(variant);
  }
}
